import { useMemo } from "react";
import { useHalls } from "api/hooks";
import { addHours, format, parse } from "date-fns";
import { uk } from "date-fns/locale/uk";
import { useSearchParams } from "react-router-dom";
import { Routes } from "router";
import { Image, Link, Typography } from "theme";
import { Calendar, Edit } from "theme/icons";

import { Box, CircularProgress, Grid2 } from "@mui/material";

const SelectedHall = () => {
  const { halls, isFetching } = useHalls();
  const [searchParams] = useSearchParams();

  const selectedHall = halls?.find((h) => String(h.id) === searchParams.get("h"));

  const selectedTime = useMemo(() => {
    const selectedDate = searchParams.get("d");
    const selectedTime = searchParams.get("t");
    const selectedRange = searchParams.get("r");

    const startDate = parse(`${selectedDate} ${selectedTime}`, "yyyy-MM-dd HH:mm", new Date());
    const endDate = addHours(startDate, Number(selectedRange));

    return `${format(startDate, "EEEE, dd MMMM HH:mm", {
      locale: uk,
    })} - ${format(endDate, "HH:mm")}`;
  }, [searchParams]);

  const selectedHour = searchParams.get("t");
  const isNightHour = selectedHour ? selectedHour >= "22:00" || selectedHour < "08:00" : false;

  if (isFetching) {
    return (
      <Grid2 container justifyContent="center">
        <CircularProgress color="secondary" />
      </Grid2>
    );
  }

  if (!selectedHall) return null;

  return (
    <Box>
      <Grid2 width="100%" container justifyContent="space-between" alignItems="center">
        <Box>
          <Grid2 container columnGap={1.5}>
            <Image src={selectedHall.imageSmallUrl} />
            <Box>
              <Typography
                textTransform="uppercase"
                weight="semiBold"
                variant="body1"
                color="primary"
                mb={0.5}
              >
                {selectedHall.name}
              </Typography>
              <Typography
                textTransform="uppercase"
                weight="light"
                variant="body1"
                color="primary"
                mb={1.25}
              >
                {isNightHour ? selectedHall.nightPricePerHour : selectedHall.pricePerHour}грн/год
              </Typography>
            </Box>
          </Grid2>
        </Box>
        <Link
          to={`${Routes.BookingCreationHallSelection}?${searchParams.has("h") ? `h=${searchParams.get("h")}` : ""}`}
        >
          <Edit />
        </Link>
      </Grid2>

      <Grid2 mt={2} width="100%" container justifyContent="space-between" alignItems="center">
        <Box>
          <Grid2 container alignItems="center" columnGap={0.75}>
            <Calendar />
            <Typography weight="light" variant="body1" color="primary" textTransform="capitalize">
              {selectedTime}
            </Typography>
          </Grid2>
        </Box>

        <Link
          to={`${Routes.BookingCreationTimeSelection}?${searchParams.has("h") ? `h=${searchParams.get("h")}` : ""}${searchParams.has("d") ? `&d=${searchParams.get("d")}` : ""}${searchParams.has("t") ? `&t=${searchParams.get("t")}` : ""}`}
        >
          <Edit />
        </Link>
      </Grid2>
    </Box>
  );
};

export default SelectedHall;
